import { render, staticRenderFns } from "./ConnectFacebook.vue?vue&type=template&id=618bc1e7"
import script from "./ConnectFacebook.vue?vue&type=script&lang=js"
export * from "./ConnectFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports